/**
 * Custom Alert Component
 * Extends Ant Design Alert with custom styling
 */

import React from 'react';
import { Alert as AntAlert, AlertProps } from 'antd';
import classNames from 'classnames';
import './CustomAlert.scss';

export interface CustomAlertProps extends AlertProps {
  /** Alert variant */
  variant?: 'default' | 'outlined' | 'filled';
}

/**
 * CustomAlert Component
 */
export const CustomAlert: React.FC<CustomAlertProps> = ({
  variant = 'default',
  className,
  ...rest
}) => {
  const alertClasses = classNames('custom-alert', `custom-alert--${variant}`, className);

  return <AntAlert {...rest} className={alertClasses} />;
};

export default CustomAlert;

